import { render, staticRenderFns } from "./ParticipationPreview.vue?vue&type=template&id=ed49bea6"
import script from "./ParticipationPreview.vue?vue&type=script&lang=js"
export * from "./ParticipationPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports